import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { initBank } from "@/lib/bank";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <div data-testid="bank-loading" style={{ minHeight: "100vh", background: "#0f172a", color: "#94a3b8", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "monospace" }}>
    Loading question bank…
  </div>
);
initBank().finally(() => root.render(
      <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  
));
